import type { ReactElement, ReactNode } from 'react';

interface SectionCardProps {
  readonly title: string;
  readonly description?: string;
  readonly error?: string | null;
  readonly children: ReactNode;
}

/** 에디터 섹션 공통 프레임 — 제목·설명·오류·본문. */
export const SectionCard = ({
  title,
  description,
  error,
  children,
}: SectionCardProps): ReactElement => (
  <section className="rounded-2xl border border-foreground/[0.06] bg-card p-6 shadow-[0_1px_2px_rgba(0,0,0,0.03)]">
    <h2 className="text-lg font-semibold tracking-[-0.01em]">{title}</h2>
    {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
    {error ? (
      <p role="alert" className="mt-2 text-sm text-destructive">
        {error}
      </p>
    ) : null}
    <div className="mt-5">{children}</div>
  </section>
);
